import { useRestClient } from '@/contexts/QueryProvider'

export function useGetGlossaryMarkdown(appId?: number) {
  const { getMarkdownApiGetGlossary } = useRestClient()
  return getMarkdownApiGetGlossary.useSuspenseQuery({ path: { applicationId: appId! } })
}

export function useSaveGlossaryMarkdown(appId?: number) {
  const { postMarkdownApiSaveGlossary } = useRestClient()
  return postMarkdownApiSaveGlossary.useMutation({ path: { applicationId: appId! } })
}
